class StickyAddToCart extends HTMLElement {
    constructor() {
        super();
        this.sticky = this;
        this.stickyBounds = document.getElementById('product-add-to-cart') || document.querySelector('[data-combo-addtocart]');
        this.closeSticky = this.querySelector('[data-close-sticky-add-to-cart]');
        this.expandSticky = this.querySelector('[data-expand-sticky-add-to-cart]');

        this.closeSticky?.addEventListener(
            'click',
            this.setCloseSticky.bind(this)
        );

        this.expandSticky?.addEventListener(
            'click',
            this.setExpandSticky.bind(this)
        );
            
        this.openStickyButton = document.getElementById('show-sticky-product');
        this.closeModal = this.closeStickyModal.bind(this);
    }

    connectedCallback() {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.openStickyButton?.addEventListener('click', this.openStickyModal.bind(this));
        document.addEventListener('click', (e) => {
            if (e.target.matches('.background-overlay') || e.target.closest('[data-close-sticky-mobile]') != null || e.target.matches('[data-close-sticky-mobile]')) {
                this.closeModal();
            }
        })
    }

    openStickyModal() {
        document.body.classList.add('show-mobile-options');
        const height = this.closest('[data-sticky-add-to-cart]').clientHeight;
        this.sticky.querySelector('.sticky-product-mobile').style.bottom = height + 'px';
    }

    closeStickyModal() {
        document.body.classList.remove('show-mobile-options');
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        let offsetScroll;

        if (this.stickyBounds != null) {
            const rect = this.stickyBounds.getBoundingClientRect();
            const top = rect.top + window.pageYOffset;
            const height = this.stickyBounds.offsetHeight;
            const marginTop = parseInt(window.getComputedStyle(this.stickyBounds).marginTop) || 0;
            const marginBottom = parseInt(window.getComputedStyle(this.stickyBounds).marginBottom) || 0;
            offsetScroll = top + height + marginTop + marginBottom + 100;
        } else {
            offsetScroll = 0;
        }

        const winHeight = window.innerHeight;
        const docHeight = document.body.clientHeight;

        if (scrollTop > offsetScroll && scrollTop + winHeight < docHeight) {
            requestAnimationFrame(this.show.bind(this));

            if (this.sticky.classList.contains('style-1')) {
                let height = 0;
                const previewBar = document.getElementById('preview-bar-iframe'),
                    toolbarMobile = document.querySelector('.halo-sticky-toolbar-mobile');

                if (previewBar && window.getComputedStyle(previewBar).display !== "none") {
                    height = previewBar.offsetHeight;
                }
                else if (toolbarMobile) {
                    height = toolbarMobile.offsetHeight;
                }

                this.sticky.style.top = 'auto';
                this.sticky.style.bottom = `${height}px`;
                document.querySelector('.quick-order-list__total')?.style.setProperty('bottom', `${height + this.offsetHeight}px`);
            }
            else if (this.sticky.classList.contains('style-2')) {
                if(document.body.classList.contains('scroll-up')){
                    let height = document.querySelector('sticky-header').offsetHeight;

                    if (window.innerWidth < 551) {
                        height = height + 20;
                    }

                    this.sticky.style.top = `${height}px`;
                } else if(document.body.classList.contains('scroll-down')) {
                    if (window.innerWidth > 550) {
                        this.sticky.style.top = 0;
                    }
                    else {
                        this.sticky.style.top = '20px';
                    }
                }
            }
        } else{
            requestAnimationFrame(this.hide.bind(this));
            if(this.sticky.classList.contains('style-1')) document.querySelector('.quick-order-list__total')?.style.setProperty('bottom', '0px');
        }

        this.currentScrollTop = scrollTop;
    }

    hide() {
        this.sticky.classList.remove('show-sticky', 'hidden-sticky', 'full-sticky', 'animate');
        document.body.classList.remove('show-mobile-options');
    }

    show() {
        this.sticky.classList.add('show-sticky', 'animate');
    }

    setCloseSticky(event){
        event.preventDefault();

        if(this.sticky.classList.contains('full-sticky')){
            this.sticky.classList.remove('full-sticky');
        } else{
            this.sticky.classList.add('hidden-sticky');
        }
    }

    setExpandSticky(event){
        event.preventDefault();

        this.sticky.classList.add('full-sticky');
    }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);

class VariantStickyAddToCart extends HTMLElement {
    constructor() {
        super();
        this.item = this.closest('.productView');
        this.sticky = this.closest('.productView-stickyCart');
        this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange(event) {
        this.updateOptions();   
        this.updateMasterId();
        this.updatePickupAvailability();
        this.updateMedia(200);
        this.updateURL();
        this.updateVariantInput();
        this.renderProductAjaxInfo();
        this.renderProductInfo();
        this.updateAttribute(!this.currentVariant.available);
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    decodeOptions() {
        this.options = this.options.map(option => {
            const parsedOption = this.decodeOption(option)
            return parsedOption
        })
    }
    
    decodeOption(option) {
      if (option) {
          return option.split('Special_Double_Quote').join('"').split('Special_Slash').join('/')
        } else {
          return null
        }
    }

    encodeOption(option) {
        if (option) {
          return option.split('"').join('Special_Double_Quote').split('/').join('Special_Slash')
        } else {
          return null
        }
    }

    updateMasterId() {
        this.decodeOptions()
        this.currentVariant = this.getVariantData().find((variant) => {
            return variant.id == this.options;
        });
    }

    updateMedia(time) {
        if (!this.currentVariant || !this.currentVariant?.featured_media) return;

        const itemImage = this.item.querySelector('.sticky-image');
        const image = this.currentVariant?.featured_image;
        if (!itemImage) return;

        const img = itemImage.querySelector('img');
        if (img) {
            img.setAttribute('src', image.src);
            img.setAttribute('srcset', image.src);
            img.setAttribute('alt', image.alt);
        }

        const newMedia = document.querySelectorAll(
            `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );

        if (!newMedia || newMedia.length === 0) return;
        window.setTimeout(() => {
            newMedia.forEach(media => {
                media.click();
            });
        }, time);
    }

    updateURL() {
        if (!this.currentVariant) return;
        window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.product}, #product-form-installment-${this.dataset.product}, #product-form-sticky-${this.dataset.product}`);
  
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant?.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    renderProductAjaxInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const id = `product-price-${this.dataset.product}`;
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = document.getElementById(id);
                const source = html.getElementById(id);

                if (source && destination) {
                    destination.innerHTML = source.innerHTML;
                }

                if (this.checkNeedToConvertCurrency()) {
                    let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                    Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                }

                document.getElementById(`product-price-${this.dataset.product}`)?.classList.remove('visibility-hidden');
        });
    }

    renderProductInfo() {
        var variantList = this.getVariantData().filter((variant) => {
            return variant.available
        }); 

        var selectedOption1 = this.currentVariant?.option1,
            selectedOption2 = this.currentVariant?.option2,
            selectedOption3 = this.currentVariant?.option3,
            options = Array.from(this.item.querySelectorAll('.product-form__input:not(.mobile)')),
            optionsMobile = Array.from(this.item.querySelectorAll('.product-form__input.mobile')),
            checkStickyVariant = false;
        // let parsedSelectedOption1 = selectedOption1 ? parseDoubleQuote(selectedOption1) : null,
        //     parsedSelectedOption2 = selectedOption2 ? parseDoubleQuote(selectedOption2) : null,
        //     parsedSelectedOption3 = selectedOption3 ? parseDoubleQuote(selectedOption3) : null;

        const renderOptions = (options) => {
            options.forEach((element, index) => {
                var position = element.dataset.optionIndex,
                    type = element.dataset.productAttribute;
                
                switch (position) {
                    case 0:
                        const headerOption0 = element.querySelector('[data-header-option]');
                        if (headerOption0) headerOption0.textContent = selectedOption1;
    
                        if(type == 'set-select') {
                            const select0 = element.querySelector('.select__select');
                            if (select0) select0.value = selectedOption1;
    
                            const selectList0 = Array.from(element.querySelectorAll('.select__select option'));
    
                            selectList0.forEach((elt) => {
                                if(elt.value == selectedOption1){
                                    elt.setAttribute('selected', 'selected');
                                } else {
                                    elt.removeAttribute('selected');
                                }
                            });
                        } else {
                            const radios0 = Array.from(element.querySelectorAll('.product-form__radio'));
                            radios0.forEach(radio => radio.checked = false);
                            const targetRadio0 = element.querySelector(`.product-form__radio[value="${this.encodeOption(selectedOption1)}"]`);
                            if (targetRadio0) {
                                targetRadio0.checked = true;
                                targetRadio0.dispatchEvent(new Event('change', { bubbles: true }));
                            }
                        }
    
                        var option1List = variantList.filter((variant) => {
                            return variant.option1 === selectedOption1;
                        });
    
                        if(selectedOption2){
                            var inputList = options[1],
                                input = Array.from(inputList.querySelectorAll('.product-form__radio')),
                                selectOption = Array.from(inputList.querySelectorAll('.select__select option'));
    
                            if(type == 'set-rectangle'){
                                input.forEach((elt, idx) => {
                                    var label = elt.nextElementSibling,
                                        optionValue = elt.value;

                                    var optionSoldout = option1List.find((variant) => {
                                        return variant.option2 == this.decodeOption(optionValue)
                                    });
    
                                  if(optionSoldout == undefined){
                                      if (label) {
                                          label.classList.remove('available');
                                          label.classList.add('soldout');
                                      }
                                      if (checkStickyVariant && inputSticky && inputSticky[idx]) {
                                          const stickyLabel = inputSticky[idx].nextElementSibling;
                                          if (stickyLabel) {
                                              stickyLabel.classList.remove('available');
                                              stickyLabel.classList.add('soldout');
                                          }
                                      }
                                  } else {
                                      if (label) {
                                          label.classList.remove('soldout');
                                          label.classList.add('available');
                                      }
                                      if (checkStickyVariant && inputSticky && inputSticky[idx]) {
                                          const stickyLabel = inputSticky[idx].nextElementSibling;
                                          if (stickyLabel) {
                                              stickyLabel.classList.remove('soldout');
                                              stickyLabel.classList.add('available');
                                          }
                                      }
                                  }
                                });
                            } else {
                                selectOption.forEach((elt, idx) => {
                                    var optionValue = elt.value;
    
                                    var optionSoldout = option1List.find((variant) => {
                                        return variant.option2 == this.decodeOption(optionValue)
                                    });
    
                                  if(optionSoldout == undefined){
                                      elt.setAttribute('disabled', 'true');
                                      if (checkStickyVariant && selectOptionSticky && selectOptionSticky[idx]) {
                                          selectOptionSticky[idx].setAttribute('disabled', 'true');
                                      }
                                  } else {
                                      elt.removeAttribute('disabled');
                                      if (checkStickyVariant && selectOptionSticky && selectOptionSticky[idx]) {
                                          selectOptionSticky[idx].removeAttribute('disabled');
                                      }
                                  }
                                });
                            }
                        }
    
                        if(selectedOption3){
                            var inputList = $(options[2]),
                                input = inputList.find('.product-form__radio'),
                                selectOption = inputList.find('.select__select option');
    
                            if(type == 'set-rectangle'){
                                input.each((idx, elt) => {
                                    var $input = $(elt),
                                        $label = $input.next(),
                                        optionValue = $(elt).val();
    
                                    var optionSoldout = option1List.find((variant) => {
                                        return variant.option3 == this.decodeOption(optionValue)
                                    });
    
                                  if(optionSoldout == undefined){
                                      $label.removeClass('available').addClass('soldout');
                                      if (checkStickyVariant) {
                                          $(inputSticky[idx]).next().removeClass('available').addClass('soldout');
                                      }
                                  } else {
                                      $label.removeClass('soldout').addClass('available');
                                      if (checkStickyVariant) {
                                          $(inputSticky[idx]).next().removeClass('soldout').addClass('available');
                                      }
                                  }
                                });
                            } else {
                                selectOption.forEach((elt, idx) => {
                                    var optionValue = elt.value;
    
                                    var optionSoldout = option1List.find((variant) => {
                                        return variant.option3 == this.decodeOption(optionValue)
                                    });
    
                                  if(optionSoldout == undefined){
                                      elt.setAttribute('disabled', 'true');
                                      if (checkStickyVariant && selectOptionSticky && selectOptionSticky[idx]) {
                                          selectOptionSticky[idx].setAttribute('disabled', 'true');
                                      }
                                  } else {
                                      elt.removeAttribute('disabled');
                                      if (checkStickyVariant && selectOptionSticky && selectOptionSticky[idx]) {
                                          selectOptionSticky[idx].removeAttribute('disabled');
                                      }
                                  }
                                });
                            }
                        }
                        
                        break;
                    case 1:
                        const headerOption1 = element.querySelector('[data-header-option]');
                        if (headerOption1) headerOption1.textContent = selectedOption2;
    
                        if(type == 'set-select') {
                            const select1 = element.querySelector('.select__select');
                            if (select1) select1.value = selectedOption2;
    
                            const selectList1 = Array.from(element.querySelectorAll('.select__select option'));
    
                            selectList1.forEach((elt) => {
                                if(elt.value == selectedOption2){
                                    elt.setAttribute('selected', 'selected');
                                } else {
                                    elt.removeAttribute('selected');
                                }
                            });
                        } else {
                            const radios1 = Array.from(element.querySelectorAll('.product-form__radio'));
                            radios1.forEach(radio => radio.checked = false);
                            const targetRadio1 = element.querySelector(`.product-form__radio[value="${this.encodeOption(selectedOption2)}"]`);
                            if (targetRadio1) {
                                targetRadio1.checked = true;
                                targetRadio1.dispatchEvent(new Event('change', { bubbles: true }));
                            }
                        }
    
                        var option2List = variantList.filter((variant) => {
                            return variant.option2 === selectedOption2;
                        });
    
                        if(selectedOption1){
                            var inputList = options[0],
                                input = Array.from(inputList.querySelectorAll('.product-form__radio')),
                                selectOption = Array.from(inputList.querySelectorAll('.select__select option'));
    
                            if(type == 'set-rectangle'){
                                input.forEach((elt, idx) => {
                                    var label = elt.nextElementSibling,
                                        optionValue = elt.value;
    
                                    var optionSoldout = option2List.find((variant) => {
                                        return variant.option1 == this.decodeOption(optionValue)
                                    });
    
                                    if(optionSoldout == undefined){
                                        if (label) {
                                            label.classList.remove('available');
                                            label.classList.add('soldout');
                                        }
                                        if (checkStickyVariant && inputSticky && inputSticky[idx]) {
                                            const stickyLabel = inputSticky[idx].nextElementSibling;
                                            if (stickyLabel) {
                                                stickyLabel.classList.remove('available');
                                                stickyLabel.classList.add('soldout');
                                            }
                                        }
                                    } else {
                                        if (label) {
                                            label.classList.remove('soldout');
                                            label.classList.add('available');
                                        }
                                        if (checkStickyVariant && inputSticky && inputSticky[idx]) {
                                            const stickyLabel = inputSticky[idx].nextElementSibling;
                                            if (stickyLabel) {
                                                stickyLabel.classList.remove('soldout');
                                                stickyLabel.classList.add('available');
                                            }
                                        }
                                    }
                                });
                            } else {
                                selectOption.forEach((elt, idx) => {
                                    var optionValue = elt.value;
    
                                    var optionSoldout = option2List.find((variant) => {
                                        return variant.option1 == this.decodeOption(optionValue)
                                    });
    
                                    if(optionSoldout == undefined){
                                        elt.setAttribute('disabled', 'true');
                                        if (checkStickyVariant && inputSticky && inputSticky[idx]) {
                                            inputSticky[idx].setAttribute('disabled', 'true');
                                        }
                                    } else {
                                        elt.removeAttribute('disabled');
                                        if (checkStickyVariant && inputSticky && inputSticky[idx]) {
                                            inputSticky[idx].removeAttribute('disabled');
                                        }
                                    }
                                });
                            }
                        }
    
                        if(selectedOption3){
                            var inputList = $(options[2]),
                                input = inputList.find('.product-form__radio'),
                                selectOption = inputList.find('.select__select option');
    
                            if(type == 'set-rectangle'){
                                input.each((idx, elt) => {
                                    var $input = $(elt),
                                        $label = $input.next(),
                                        optionValue = $(elt).val();
    
                                    var optionSoldout = option2List.find((variant) => {
                                        return variant.option3 == this.decodeOption(optionValue)
                                    });
    
                                    if(optionSoldout == undefined){
                                        $label.removeClass('available').addClass('soldout');
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).next().removeClass('available').addClass('soldout');
                                        }
                                    } else {
                                        $label.removeClass('soldout').addClass('available');
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).next().removeClass('soldout').addClass('available');
                                        }
                                    }
                                });
                            } else {
                                electOption.each((idx, elt) => {
                                    var $option = $(elt),
                                        optionValue = $(elt).val();
    
                                    var optionSoldout = option2List.find((variant) => {
                                        return variant.option3 == this.decodeOption(optionValue)
                                    });
    
                                    if(optionSoldout == undefined){
                                        $option.attr('disabled', true);
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).attr('disabled', true);
                                        }
                                    } else {
                                        $option.removeAttr('disabled');
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).removeAttr('disabled');
                                        }
                                    }
                                });
                            }
                        }
                        
                        break;
                    case 2:
                        const headerOption2 = element.querySelector('[data-header-option]');
                        if (headerOption2) headerOption2.textContent = selectedOption3;
    
                        if(type == 'set-select') {
                            const select2 = element.querySelector('.select__select');
                            if (select2) select2.value = selectedOption3;
    
                            const selectList2 = Array.from(element.querySelectorAll('.select__select option'));
    
                            selectList2.forEach((elt) => {
                                if(elt.value == selectedOption3){
                                    elt.setAttribute('selected', 'selected');
                                } else {
                                    elt.removeAttribute('selected');
                                }
                            });
                        } else {
                            const radios2 = Array.from(element.querySelectorAll('.product-form__radio'));
                            radios2.forEach(radio => radio.checked = false);
                            const targetRadio2 = element.querySelector(`.product-form__radio[value="${this.encodeOption(selectedOption3)}"]`);
                            if (targetRadio2) {
                                targetRadio2.checked = true;
                                targetRadio2.dispatchEvent(new Event('change', { bubbles: true }));
                            }
                        }
    
                        var option3List = variantList.filter((variant) => {
                            return variant.option3 === selectedOption3;
                        });
    
                        if(selectedOption1){
                            var inputList = $(options[0]),
                                input = inputList.find('.product-form__radio'),
                                selectOption = inputList.find('.select__select option');
    
                            if(type == 'set-rectangle'){
                                input.each((idx, elt) => {
                                    var $input = $(elt),
                                        $label = $input.next(),
                                        optionValue = $(elt).val();
    
                                    var optionSoldout = option3List.find((variant) => {
                                        return variant.option1 == this.decodeOption(optionValue)
                                    });
    
                                     if(optionSoldout == undefined){
                                        $label.removeClass('available').addClass('soldout');
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).next().removeClass('available').addClass('soldout');
                                        }
                                    } else {
                                        $label.removeClass('soldout').addClass('available');
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).next().removeClass('soldout').addClass('available');
                                        }
                                    }
                                });
                            } else {
                                selectOption.each((idx, elt) => {
                                    var $option = $(elt),
                                        optionValue = $(elt).val();
    
                                    var optionSoldout = option3List.find((variant) => {
                                        return variant.option1 == this.decodeOption(optionValue)
                                    });
    
                                   if(optionSoldout == undefined){
                                      $option.attr('disabled', true);
                                      if (checkStickyVariant) {
                                          $(inputSticky[idx]).attr('disabled', true);
                                      }
                                  } else {
                                      $option.removeAttr('disabled');
                                      if (checkStickyVariant) {
                                          $(inputSticky[idx]).removeAttr('disabled');
                                      }
                                  }
                                });
                            }
                        }
    
                        if(selectedOption2){
                            var inputList = $(options[1]),
                                input = inputList.find('.product-form__radio');
    
                            if(type == 'set-rectangle'){
                                input.each((idx, elt) => {
                                    var $input = $(elt),
                                        $label = $input.next(),
                                        optionValue = $(elt).val();
    
                                    var optionSoldout = option3List.find((variant) => {
                                        return variant.option2 == this.decodeOption(optionValue)
                                    });
    
                                    if(optionSoldout == undefined){
                                        $label.removeClass('available').addClass('soldout');
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).next().removeClass('available').addClass('soldout');
                                        }
                                    } else {
                                        $label.removeClass('soldout').addClass('available');
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).next().removeClass('soldout').addClass('available');
                                        }
                                    }
                                });
                            } else {
                                selectOption.each((idx, elt) => {
                                    var $option = $(elt),
                                        optionValue = $(elt).val();
    
                                    var optionSoldout = option3List.find((variant) => {
                                        return variant.option2 == this.decodeOption(optionValue)
                                    });
    
                                     if(optionSoldout == undefined){
                                        $option.attr('disabled', true);
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).attr('disabled', true);
                                        }
                                    } else {
                                        $option.removeAttr('disabled');
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).removeAttr('disabled');
                                        }
                                    }
                                });
                            }
                        }
                        
                        break;
                }
            }); 
        }

        renderOptions(options)
        renderOptions(optionsMobile)

        const skuElement = this.item.querySelector('[data-sku]');
        if(skuElement){
            const skuValue = skuElement.querySelector('.productView-info-value');
            if (skuValue) skuValue.textContent = this.currentVariant.sku;
        }

        const barcodeElement = this.item.querySelector('[data-barcode]');
        if(barcodeElement){
            const barcodeValue = barcodeElement.querySelector('.productView-info-value');
            if (barcodeValue) barcodeValue.textContent = this.currentVariant.barcode;
        }

        var inventory = this.currentVariant?.inventory_management;

        if(inventory != null) {
            var arrayInVarName = `product_inven_array_${this.dataset.product}`,
                inven_array = window[arrayInVarName];

            if(inven_array != undefined) {
                var inven_num = inven_array[this.currentVariant.id],
                    inputQuantity = this.item.querySelector('input[name="quantity"]'),
                    buttonSubmit = this.item.querySelector('button#product-sticky-add-to-cart'),
                    inventoryQuantity = parseInt(inven_num);

                    if(inputQuantity) {
                        inputQuantity.setAttribute('data-inventory-quantity', inventoryQuantity);
                    } else if (buttonSubmit) {
                        buttonSubmit.setAttribute('data-inventory-quantity', inventoryQuantity);
                    }

                const inventoryElement = this.item.querySelector('[data-inventory]');
                if(inventoryElement){
                    const inventoryValue = inventoryElement.querySelector('.productView-info-value');
                    if (inventoryValue) {
                        if(inventoryQuantity > 0){
                            inventoryValue.textContent = window.inventory_text.inStock;
                        } else {
                            inventoryValue.textContent = window.inventory_text.outOfStock;
                        }
                    }
                }

                const hotStock = this.item.querySelector('.productView-hotStock');
                if(hotStock){
                    const maxStock = hotStock.dataset.hotStock;

                    if(inventoryQuantity > 0 && inventoryQuantity <= maxStock){
                        var textStock = window.inventory_text.hotStock.replace('[inventory]', inventoryQuantity);
                        hotStock.textContent = textStock;
                        hotStock.style.display = '';
                    } else {
                        hotStock.style.display = 'none';
                    }
                }
            }
        }
    }

    updateAttribute(disable = true){
        const addButton = document.getElementById(`product-form-${this.dataset.product}`)?.querySelector('[name="add"]');
        const stickyButton = document.getElementById(`product-form-sticky-${this.dataset.product}`)?.querySelector('[name="add"]');

        const stickyCart = document.querySelector('[data-sticky-add-to-cart]');
        var quantityInput = stickyCart?.querySelector('.quantity__input'),
            submitBtn = stickyCart?.querySelector('.product-form__submit'),
            notifyMe = this.item.querySelector('.productView-notifyMe'),
            stickyPrice = stickyCart?.querySelector('.money-subtotal .money');
        var maxValue;

        if (quantityInput) {
            maxValue = parseInt(quantityInput.getAttribute('data-inventory-quantity'));
        } else if (submitBtn) {
            maxValue = parseInt(submitBtn.getAttribute('data-inventory-quantity'));
        }

        if (!stickyPrice && stickyCart) {
           stickyPrice = stickyCart.querySelector('.sticky-price .money-subtotal');
        }

        if (disable) {
            var text = window.variantStrings.soldOut;

            this.item.classList.remove('isChecked');
            if (quantityInput) {
                quantityInput.setAttribute('data-price', this.currentVariant?.price);
                quantityInput.setAttribute('disabled', 'true');
            }
            if (addButton != null){
                addButton.setAttribute('disabled', true);
                addButton.textContent = text;
            }
            if (stickyButton) {
                stickyButton.setAttribute('disabled', true);
                stickyButton.textContent = text;
            }

            if(notifyMe){
                const variantInput = notifyMe.querySelector('.halo-notify-product-variant');
                if (variantInput) variantInput.value = this.currentVariant.title;
                const notifyText = notifyMe.querySelector('.notifyMe-text');
                if (notifyText) notifyText.innerHTML = '';
                notifyMe.style.display = '';
            }
        } else{
            var text,
                subTotal = 0,
                price = this.currentVariant?.price;

            if(window.subtotal.show) {
                let qty = quantityInput ? (quantityInput.value || 1) : 1;
              
                subTotal = qty * price;
                subTotal = Shopify.formatMoney(subTotal, window.money_format);
                subTotal = extractContent(subTotal);

                const moneySpan = document.createElement('span')
                moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal')
                moneySpan.innerText = subTotal
                document.body.appendChild(moneySpan)

                if (this.checkNeedToConvertCurrency()) {
                    let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                    Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                }

                subTotal = moneySpan.innerText
                moneySpan.remove()

                if (window.subtotal.style == '1') {
                    const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');
                    
                    if(pdView_subTotal != null){
                        if(document.body.classList.contains('disable_currencies')) {
                            const pdView_subTotal2 = document.querySelector('.productView-subtotal .money-subtotal');
                            if (pdView_subTotal2) pdView_subTotal2.innerHTML = subTotal;
                        } else {
                            pdView_subTotal.textContent = subTotal;
                        }
                    }

                    if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                        text = window.variantStrings.preOrder;
                    } else {
                        text = window.variantStrings.addToCart;
                    }
                }
                else if (window.subtotal.style == '2') {
                    if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                        text = window.variantStrings.preOrder;
                    } else {
                        if(document.body.classList.contains('disable_currencies')) {
                            const tempSpan = document.createElement('span');
                            tempSpan.innerHTML = subTotal;
                            subTotal = tempSpan.textContent || tempSpan.innerText;
                        }
                        text = window.subtotal.text.replace('[value]', subTotal);
                    }
                }
            } else {
                subTotal = Shopify.formatMoney(price, window.money_format);
                if (window.currencyFormatted) {
                    const tempSpan = document.createElement('span');
                    tempSpan.innerHTML = subTotal;
                    subTotal = tempSpan.textContent || tempSpan.innerText;
                }

                const moneySpan = document.createElement('span')
                moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal')
                moneySpan.innerText = subTotal
                document.body.appendChild(moneySpan)

                if (this.checkNeedToConvertCurrency()) {
                    let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                    Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                }

                subTotal = moneySpan.innerText
                moneySpan.remove()

                if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                    text = window.variantStrings.preOrder;
                } else {
                    text = window.variantStrings.addToCart;
                }
            }

            this.item.classList.add('isChecked');
            if (quantityInput) {
                quantityInput.setAttribute('data-price', this.currentVariant?.price);
                quantityInput.removeAttribute('disabled');
            }
            if (addButton != null){
                addButton.removeAttribute('disabled');
                addButton.textContent = text;
            }
            if (stickyButton) {
                stickyButton.removeAttribute('disabled');
                stickyButton.textContent = text;
            }

            if (subTotal != 0 && stickyPrice) {
                if(document.body.classList.contains('disable_currencies')) {
                    const stickyPrice2 = stickyCart?.querySelector('.sticky-price .money-subtotal');
                    if (stickyPrice2) stickyPrice2.innerHTML = subTotal;
                } else {
                    stickyPrice.textContent = subTotal;
                }
            }

            const thisStickyPrice = stickyCart?.querySelector('.sticky-price');
            const thisComparePrice = stickyCart?.querySelector('.money-compare-price');
            const compare_at_price = this.currentVariant?.compare_at_price;
            if (compare_at_price && thisStickyPrice) {
                thisStickyPrice.classList.add('has-compare-price');
                if (thisComparePrice) {
                    thisComparePrice.setAttribute('data-compare-price', compare_at_price);

                    const compare_at_price_sticky = Shopify.formatMoney(compare_at_price, window.money_format);
                    const comparePrice_sticky = extractContent(compare_at_price_sticky);
                    thisComparePrice.textContent = comparePrice_sticky;
                    
                    if (this.checkNeedToConvertCurrency()) {
                        let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                        Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                    }

                    const newComparePrice = document.createElement('s');
                    newComparePrice.className = 'money-compare-price';
                    newComparePrice.setAttribute('data-compare-price', compare_at_price);
                    newComparePrice.innerHTML = '<span class="money"></span>';
                    thisStickyPrice.insertBefore(newComparePrice, thisStickyPrice.firstChild);
                    thisComparePrice.remove();
                } else {
                    const newComparePrice = document.createElement('s');
                    newComparePrice.className = 'money-compare-price';
                    newComparePrice.setAttribute('data-compare-price', compare_at_price);
                    newComparePrice.innerHTML = '<span class="money"></span>';
                    thisStickyPrice.insertBefore(newComparePrice, thisStickyPrice.firstChild);
                }
            } else if (thisStickyPrice) {
                thisStickyPrice.classList.remove('has-compare-price');
                if (thisComparePrice) thisComparePrice.remove();
            }
            
            const stickyComparePrice = stickyCart?.querySelector('.money-compare-price .money');

            if (subTotal != 0 && stickyComparePrice && window.subtotal.show) {
                const comparePriceEl = stickyCart?.querySelector('.money-compare-price');
                let comparePrice = comparePriceEl ? comparePriceEl.getAttribute('data-compare-price') : null;
                if (comparePrice) {
                    const qty = quantityInput ? (quantityInput.value || 1) : 1;
                    comparePrice = qty * parseFloat(comparePrice);
                    comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
                    comparePrice = extractContent(comparePrice);
                    stickyComparePrice.textContent = comparePrice;
                }
            }

            if(notifyMe){
                notifyMe.style.display = 'none';
            }
        }
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    checkNeedToConvertCurrency() {
        var currencyItem = document.querySelector('.dropdown-item[data-currency]');
        if (currencyItem) {
            return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
        } else {
            return;
        }
    }
}

customElements.define('variant-sticky-selects', VariantStickyAddToCart);

class VariantStickyRadios extends VariantStickyAddToCart {
    constructor() {
        super();        
    }

    connectedCallback() {
        this.updateMediaTimeout = undefined
    }

    onVariantChange(event) {
        this.updateOptions();   
        this.updateMasterId();
        this.updatePickupAvailability();
        this.updateMedia(10);
        this.updateURL();
        this.updateVariantInput();
        this.updateSelectVariant();
        this.renderProductAjaxInfo();
        this.renderProductInfo();
        this.updateAttribute(!this.currentVariant.available);
    }   

    updateOptions() {   
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }

    decodeOptions() {
        this.options = this.options.map(option => {
            const parsedOption = this.decodeOption(option)
            return parsedOption
        })
    }
  
    decodeOption(option) {
      if (option) {
          return option.split('Special_Double_Quote').join('"').split('Special_Slash').join('/')
        } else {
          return null
        }
    }

    encodeOption(option) {
        if (option) {
          return option.split('"').join('Special_Double_Quote').split('/').join('Special_Slash')
        } else {
          return null
        }
    }

    updateSelectVariant() {
        const selectElement = this.closest('.productView-stickyCart').querySelector('select');
        selectElement.value = this.currentVariant.id
    }

    updateMasterId() {
        this.decodeOptions()
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateMedia(time) {
        if (!this.currentVariant || !this.currentVariant?.featured_media) return;

        const itemImage = this.item.querySelector('.sticky-image');
        const image = this.currentVariant?.featured_image;
        if (!itemImage) return;

        const img = itemImage.querySelector('img');
        if (img) {
            img.setAttribute('src', image.src);
            img.setAttribute('srcset', image.src);
            img.setAttribute('alt', image.alt);
        }

        const newMedia = document.querySelectorAll(
            `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );

        if (!newMedia || newMedia.length === 0) return;
        
        clearTimeout(this.updateMediaTimeout);
        this.updateMediaTimeout = setTimeout(() => {
            newMedia.forEach(media => {
                media.click();
            });
        }, time);
    }

    openStickyModal() {
        document.body.classList.add('show-mobile-options');
    }

    closeStickyModal() {
        document.body.classList.remove('show-mobile-options');
    }
}

customElements.define('variant-sticky-radios', VariantStickyRadios);

function parseDoubleQuote(option, isDecoding = true) {
    if (!option) return option;
    
    if (isDecoding) {
      return option.replace('"', 'spc_dbl_qte')
    } else {
      return option.replace('spc_dbl_qte', '"')
    }
}